import { render } from "./DictionaryItemCard.vue?vue&type=template&id=391a1c7e&scoped=true"
import script from "./DictionaryItemCard.vue?vue&type=script&lang=js"
export * from "./DictionaryItemCard.vue?vue&type=script&lang=js"

import "./DictionaryItemCard.vue?vue&type=style&index=0&id=391a1c7e&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-391a1c7e"]])

export default __exports__